module.exports = __webpack_public_path__ + "static/img/3.d1c77e8c.jpg";